export const PADDING = 32;

export const TITLE_ICON_SIZE = 10;

export const SCALAR_TITLE_LINE_HEIGHT = 23;

export const TITLE_2_LINES_HEIGHT_THRESHOLD = 120; // determined empirically
